import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/smile-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM365.8 309.6C355.6 301.1 340.5 302.5 332 312.7 311.2 337.7 280.5 352.1 248 352.1S184.8 337.8 164 312.7C155.5 302.5 140.3 301.2 130.2 309.6 120 318.1 118.7 333.2 127.1 343.4 157.1 379.4 201.2 400 248 400S338.9 379.4 368.9 343.4C377.4 333.2 376 318.1 365.8 309.6zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 180C302.3 180 272.1 196.9 268.1 222.1 266.4 233.3 279.6 240.3 287.9 232.9L297.4 224.4C312.2 211.2 343.6 211.2 358.4 224.4L367.9 232.9C376.4 240.3 389.5 233.2 387.7 222.1 383.9 196.9 353.7 180 328 180z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/smile-wink.js
// module id = m4Ab
// module chunks = 144